@let apiResponse = data();
@if (apiResponse) {
  <p-table
    [value]="apiResponse.data"
    [loading]="kundeService.datasource.isLoading()"
    [showGridlines]="true"
    [scrollable]="true"
    scrollHeight="flex"
    stripedRows
    class="p-datatable-sm lp-table"
    selectionMode="single"
    [metaKeySelection]="true"
    (onRowSelect)="onRowSelect($event)"
    dataKey="id"
    [lazy]="true"
    [lazyLoadOnInit]="false"
    (onLazyLoad)="onLazyLoad($event)"
    sortField="fornavn"
    [sortOrder]="1"
    [paginator]="true"
    [rows]="100"
    [totalRecords]="apiResponse.totalRowCount"
    [showJumpToPageDropdown]="true"
    letKeepScrollPosition>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="fornavn">
          Navn
          <p-sortIcon field="fornavn" />
        </th>
        <th pSortableColumn="intpengeinstitut.hovedRegNr" style="width: 120px">
          Regnr
          <p-sortIcon field="intpengeinstitut.hovedRegNr" />
        </th>
        <th pSortableColumn="intpengeinstitut.navn">
          Pengeinstitut
          <p-sortIcon field="intpengeinstitut.navn" />
        </th>
        <th
          pSortableColumn="IntPersonOplysninger.cprNummer"
          style="width: 140px">
          CPR nummer
          <p-sortIcon field="IntPersonOplysninger.cprNummer" />
        </th>
        <th pSortableColumn="email" style="width: 300px">
          Email
          <p-sortIcon field="email" />
        </th>
        <th pSortableColumn="mobilTelefon" style="width: 140px">
          Telefon
          <p-sortIcon field="mobilTelefon" />
        </th>
      </tr>
    </ng-template>
    <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
      <tr [pSelectableRow]="item" class="cursor-pointer">
        <td>{{ item.navn }}</td>
        <td>{{ item.pengeinstitut?.regnr }}</td>
        <td>{{ item.pengeinstitut?.navn }}</td>
        <td>{{ item.cprNummer | cprNummer }}</td>
        <td>{{ item.email }}</td>
        <td>{{ item.mobilTelefon }}</td>
      </tr>
    </ng-template>
  </p-table>
}
